export default __webpack_public_path__ + "static/media/about5.f2b01d14.jpg";